// localStorage 常量定义

export const IS_FIRST_VISIT = 'c_isFirstvisit';

export const IS_REGISTER = 'c_isRegister';
